Vue.component('adminRewardFrames', {
  template: templates.adminRewardFrames,
  data() {
    return {
      model: {
        edit: false,
        rewardFrame: {
          id: null,
          frame_id: null,
          frame_ids: [], // For multiple selection
          reward_type: 'shop',
          reward_name: null,
          reward_id: null,
          currency_type: 'barks',
          currency_amount: null,
          required_level: 0,
          quest_id: null,
          event_id: null,
          chest_type: null,
          drop_rate: null,
          is_guaranteed: false,
          is_active: true,
          is_featured: false,
          unlock_type: 'frame',
          start_date: null,
          end_date: null,
          max_claims: null,
          sort_order: 0,
          description: null
        },
        rewardFrames: {},
        rewardBackgrounds: {},
        frames: {},
        backgrounds: {},
        chests: {},
        quests: {},
        events: {},
        selectedFrame: null,
        selectedFrames: [], // For multiple selection preview
        filterType: 'all',
        activeTab: 'rewards' // New: track which tab is active
      },
      rewardTypes: [
        { value: 'quest', label: 'Quest Reward' },
        { value: 'event', label: 'Event Reward' },
        { value: 'shop', label: 'Shop Item' },
        { value: 'chest', label: 'Chest Drop' }
      ],
      unlockTypes: [
        { value: 'frame', label: 'Frame Only' },
        { value: 'background', label: 'Background Only' },
        { value: 'multiple', label: 'Select Multiple' }
      ],
      currencyTypes: [
        { value: 'barks', label: 'Barks' },
      ]
    }
  },
  computed: {
    filteredRewards() {
      const c = this;
      // Merge both reward frames and backgrounds
      const allRewards = [
        ...Object.values(c.model.rewardFrames).map(r => ({ ...r, _type: 'frame' })),
        ...Object.values(c.model.rewardBackgrounds).map(r => ({ ...r, _type: 'background' }))
      ];

      if (c.model.filterType === 'all') {
        return allRewards;
      }
      return allRewards.filter(r => r.reward_type === c.model.filterType);
    },
    availableFrames() {
      const c = this;
      const unlockType = c.model.rewardFrame.unlock_type;
      let available = [];

      if (unlockType === 'frame') {
        // Show only frames (from frames API)
        available = Object.values(c.model.frames).map(frame => ({
          ...frame,
          type: 'frame',
          displayName: `${frame.name} [Frame]`
        }));
      } else if (unlockType === 'background') {
        // Show only backgrounds (from backgrounds API)
        available = Object.values(c.model.backgrounds).map(bg => ({
          ...bg,
          type: 'background',
          displayName: `${bg.name} [Background]`
        }));
      } else if (unlockType === 'multiple') {
        // Combine both frames AND backgrounds into single list
        const frames = Object.values(c.model.frames).map(frame => ({
          ...frame,
          type: 'frame',
          displayName: `${frame.name} [Frame]`
        }));

        const backgrounds = Object.values(c.model.backgrounds).map(bg => ({
          ...bg,
          type: 'background',
          displayName: `${bg.name} [Background]`
        }));

        available = [...frames, ...backgrounds];
      }

      return available;
    },
    showShopFields() {
      return this.model.rewardFrame.reward_type === 'shop';
    },
    showQuestFields() {
      return this.model.rewardFrame.reward_type === 'quest';
    },
    showEventFields() {
      return this.model.rewardFrame.reward_type === 'event';
    },
    showChestFields() {
      return this.model.rewardFrame.reward_type === 'chest';
    }
  },
  mounted() {
    const c = this;
    c.getFrames();
    c.getBackgrounds();
    c.getChests();
    c.getQuests();
    c.getEvents();
    c.getRewardFrames();
    c.getRewardBackgrounds();

    c.$root.$on('frame-upload-success', data => {
      if (c.model.frames[`${data.id}`]) {
        const ext = data.filename ? data.filename.split('.').pop() : null;
        Vue.set(c.model.frames[`${data.id}`], 'frameImage',
          `${root}/images/frames/${data.id}/${data.id}.${ext}?t=${Date.now()}`
        );
        Vue.set(c.model.frames[`${data.id}`], 'uploaded', true);
      }
    });
  },
  methods: {
    getFrames() {
      const c = this;
      let data = {};

      frameService.get()
        .then(function (response) {
          for (let d of response.data) {
            // Set up image path using stored extension
            d.frameImage = d.uploaded && d.extension
              ? `${root}/images/frames/${d.id}/${d.id}.${d.extension}?t=${Date.now()}`
              : null;
            data[`${d.id}`] = d;
          }
          c.model.frames = data;
        })
        .catch(function (error) {
          console.error('Error loading frames:', error);
        });
    },

    getBackgrounds() {
      const c = this;
      let data = {};

      backgroundService.get()
        .then(function (response) {
          for (let d of response.data) {
            // Set up image path using stored extension
            d.backgroundImage = d.extension
              ? `${root}/images/backgrounds/${d.id}/${d.id}.${d.extension}?t=${Date.now()}`
              : null;
            data[`${d.id}`] = d;
          }
          c.model.backgrounds = data;
        })
        .catch(function (error) {
          console.error('Error loading backgrounds:', error);
        });
    },

    getChests() {
      const c = this;
      let data = {};

      packService.get()
        .then(function (response) {
          // Filter for chests only (isChest === true)
          const chests = response.data.filter(pack => pack.isChest === true);

          for (let chest of chests) {
            data[`${chest.id}`] = chest;
          }
          c.model.chests = data;
        })
        .catch(function (error) {
          console.error('Error loading chests:', error);
        });
    },

    getQuests() {
      const c = this;
      let data = {};

      questLineService.get()
        .then(function (response) {
          // Store all active quests (including seasonal quests)
          for (let quest of response.data) {
            data[`${quest.id}`] = quest;
          }
          c.model.quests = data;
        })
        .catch(function (error) {
          console.error('Error loading quests:', error);
        });
    },

    getEvents() {
      const c = this;
      let data = {};

      eventsService.get()
        .then(function (response) {
          // Store all active events
          for (let event of response.data) {
            data[`${event.id}`] = event;
          }
          c.model.events = data;
        })
        .catch(function (error) {
          console.error('Error loading events:', error);
        });
    },

    getRewardFrames() {
      const c = this;
      let data = {};

      rewardFrameService.get()
        .then(function (response) {
          console.log(response)
          // Response can be grouped or flat
          if (response.data.quest) {
            // Grouped response
            ['quest', 'event', 'shop', 'chest'].forEach(type => {
              if (response.data[type]) {
                response.data[type].forEach(reward => {
                  data[`${reward.id}`] = reward;
                });
              }
            });
          } else {
            // Flat response
            response.data.forEach(reward => {
              data[`${reward.id}`] = reward;
            });
          }
          c.model.rewardFrames = data;
        })
        .catch(function (error) {
          console.error('Error loading reward frames:', error);
        });
    },

    getRewardBackgrounds() {
      const c = this;
      let data = {};

      rewardBackgroundService.get()
        .then(function (response) {
          // Response can be grouped or flat
          if (response.data.quest) {
            // Grouped response
            ['quest', 'event', 'shop', 'chest'].forEach(type => {
              if (response.data[type]) {
                response.data[type].forEach(reward => {
                  data[`${reward.id}`] = reward;
                });
              }
            });
          } else {
            // Flat response
            response.data.forEach(reward => {
              data[`${reward.id}`] = reward;
            });
          }
          c.model.rewardBackgrounds = data;
        })
        .catch(function (error) {
          console.error('Error loading reward backgrounds:', error);
        });
    },

    add() {
      const c = this;
      c.reset();
      c.model.edit = true;
    },

    edit(id, type) {
      const c = this;

      // Get data from appropriate collection
      let data = type === 'background'
        ? c.model.rewardBackgrounds[`${id}`]
        : c.model.rewardFrames[`${id}`];

      if (id == c.model.rewardFrame.id) {
        c.model.edit = false;
        c.reset();
      } else {
        c.model.edit = true;
      }

      // Map background_id to frame_id for UI compatibility
      const itemId = data.frame_id || data.background_id;

      c.model.rewardFrame = {
        id: data.id,
        frame_id: itemId,
        frame_ids: [],
        reward_type: data.reward_type || 'shop',
        reward_name: data.reward_name,
        reward_id: data.reward_id,
        currency_type: data.currency_type || 'barks',
        currency_amount: data.currency_amount,
        required_level: data.required_level || 0,
        quest_id: data.quest_id,
        event_id: data.event_id,
        chest_type: data.chest_type,
        drop_rate: data.drop_rate,
        is_guaranteed: data.is_guaranteed,
        is_active: data.is_active,
        is_featured: data.is_featured,
        unlock_type: type === 'background' ? 'background' : 'frame',
        start_date: data.start_date,
        end_date: data.end_date,
        max_claims: data.max_claims,
        sort_order: data.sort_order || 0,
        description: data.description
      };

      // Set selected frame/background for preview
      if (type === 'background' && data.background_id && c.model.backgrounds[data.background_id]) {
        c.model.selectedFrame = c.model.backgrounds[data.background_id];
      } else if (data.frame_id && c.model.frames[data.frame_id]) {
        c.model.selectedFrame = c.model.frames[data.frame_id];
      }
    },

    save() {
      const c = this;
      const data = c.model.rewardFrame;

      // Determine if using multiple selection
      const isMultiple = c.model.rewardFrame.unlock_type === 'multiple' &&
                        Array.isArray(data.frame_ids) &&
                        data.frame_ids.length > 0;

      // Validation
      if (!isMultiple && !data.frame_id) {
        utils.alert.error('Please select a frame/background');
        return;
      }

      if (isMultiple && data.frame_ids.length === 0) {
        utils.alert.error('Please select at least one item');
        return;
      }

      if (!data.reward_name) {
        utils.alert.error('Reward name is required');
        return;
      }

      // Type-specific validation
      if (data.reward_type === 'shop') {
        if (!data.currency_amount || data.currency_amount <= 0) {
          utils.alert.error('Price must be greater than 0');
          return;
        }
      }

      if (data.reward_type === 'event') {
        if (!data.event_id) {
          utils.alert.error('Please select an event');
          return;
        }
      }

      if (data.reward_type === 'chest') {
        if (!data.chest_type) {
          utils.alert.error('Chest type is required');
          return;
        }
        if (!data.is_guaranteed && (!data.drop_rate || data.drop_rate <= 0)) {
          utils.alert.error('Drop rate must be greater than 0 (or mark as guaranteed)');
          return;
        }
      }

      // Handle multiple selections
      if (isMultiple) {
        // Separate frames and backgrounds
        const selectedFrames = data.frame_ids.filter(function(id) {
          return c.model.frames[id] !== undefined;
        });
        const selectedBackgrounds = data.frame_ids.filter(function(id) {
          return c.model.backgrounds[id] !== undefined;
        });

        let savedCount = 0;
        const totalCount = selectedFrames.length + selectedBackgrounds.length;

        // Save frames to reward_frames table
        selectedFrames.forEach(function(frameId) {
          const recordData = {
            ...data,
            frame_id: frameId,
            unlock_type: 'frame' // Individual records should be marked as 'frame'
          };
          delete recordData.frame_ids;
          delete recordData.background_id;

          rewardFrameService.save(recordData)
            .then(function () {
              savedCount++;
              if (savedCount === totalCount) {
                utils.alert.success(`Successfully saved ${totalCount} reward assignment(s)`);
                c.getRewardFrames();
                c.getRewardBackgrounds();
                c.reset();
              }
            })
            .catch(function (error) {
              utils.alert.error(`Failed to save reward for frame ${frameId}`);
              console.error(error);
            });
        });

        // Save backgrounds to reward_backgrounds table
        selectedBackgrounds.forEach(function(backgroundId) {
          const recordData = {
            ...data,
            background_id: backgroundId,
            unlock_type: 'background' // Individual records should be marked as 'background'
          };
          delete recordData.frame_ids;
          delete recordData.frame_id;

          rewardBackgroundService.save(recordData)
            .then(function () {
              savedCount++;
              if (savedCount === totalCount) {
                utils.alert.success(`Successfully saved ${totalCount} reward assignment(s)`);
                c.getRewardFrames();
                c.getRewardBackgrounds();
                c.reset();
              }
            })
            .catch(function (error) {
              utils.alert.error(`Failed to save reward for background ${backgroundId}`);
              console.error(error);
            });
        });
      } else {
        // Single selection - validate type matches unlock_type
        const selectedItem = c.availableFrames.find(item => item.id === data.frame_id);

        if (!selectedItem) {
          utils.alert.error('Please select a valid item');
          return;
        }

        // Validate that selected item type matches unlock type
        if (data.unlock_type === 'frame' && selectedItem.type !== 'frame') {
          utils.alert.error('Please select a frame when unlock type is "Frame Only"');
          return;
        }

        if (data.unlock_type === 'background' && selectedItem.type !== 'background') {
          utils.alert.error('Please select a background when unlock type is "Background Only"');
          return;
        }

        // Save to appropriate table based on unlock_type
        if (data.unlock_type === 'frame') {
          const recordData = {
            ...data,
            frame_id: data.frame_id
          };
          delete recordData.background_id;
          delete recordData.frame_ids;

          rewardFrameService.save(recordData)
            .then(function (response) {
              if (response.success) {
                utils.alert.success(response.message);
                c.getRewardFrames();
                c.reset();
              } else {
                utils.alert.error(response.message);
              }
            })
            .catch(function (error) {
              utils.alert.error('Failed to save reward frame');
              console.error(error);
            });
        } else if (data.unlock_type === 'background') {
          const recordData = {
            ...data,
            background_id: data.frame_id
          };
          delete recordData.frame_id;
          delete recordData.frame_ids;

          rewardBackgroundService.save(recordData)
            .then(function (response) {
              if (response.success) {
                utils.alert.success(response.message);
                c.getRewardBackgrounds();
                c.reset();
              } else {
                utils.alert.error(response.message);
              }
            })
            .catch(function (error) {
              utils.alert.error('Failed to save reward background');
              console.error(error);
            });
        }
      }
    },

    deleteReward(id, type) {
      const c = this;

      if (!confirm('Are you sure you want to delete this reward assignment?')) {
        return;
      }

      // Delete from appropriate table based on type
      const service = type === 'background' ? rewardBackgroundService : rewardFrameService;

      service.delete(id)
        .then(function (response) {
          if (response.success) {
            utils.alert.success('Reward deleted successfully');
            c.getRewardFrames();
            c.getRewardBackgrounds();
          } else {
            utils.alert.error(response.message);
          }
        })
        .catch(function (error) {
          utils.alert.error('Failed to delete reward');
          console.error(error);
        });
    },

    reset() {
      const c = this;
      c.model.edit = false;
      c.model.selectedFrame = null;
      c.model.selectedFrames = [];
      c.model.rewardFrame = {
        id: null,
        frame_id: null,
        frame_ids: [],
        reward_type: 'shop',
        reward_name: null,
        reward_id: null,
        currency_type: 'barks',
        currency_amount: null,
        required_level: 0,
        quest_id: null,
        event_id: null,
        chest_type: null,
        drop_rate: null,
        is_guaranteed: false,
        is_active: true,
        is_featured: false,
        unlock_type: 'frame',
        start_date: null,
        end_date: null,
        max_claims: null,
        sort_order: 0,
        description: null
      };
    },

    selectFrame(frameId) {
      const c = this;
      c.model.rewardFrame.frame_id = frameId;

      // Find the selected item in availableFrames to get its type
      const selectedItem = c.availableFrames.find(item => item.id === frameId);

      if (selectedItem) {
        // Look in the appropriate collection based on the item's type
        if (selectedItem.type === 'background') {
          c.model.selectedFrame = c.model.backgrounds[frameId];
        } else {
          c.model.selectedFrame = c.model.frames[frameId];
        }
      }
    },

    selectFrames() {
      const c = this;
      // Update preview for multiple selections
      c.model.selectedFrames = c.model.rewardFrame.frame_ids.map(function(frameId) {
        const item = c.availableFrames.find(f => f.id === frameId);
        if (!item) return null;

        if (item.type === 'background') {
          return c.model.backgrounds[frameId];
        } else {
          return c.model.frames[frameId];
        }
      }).filter(Boolean);
    },

    getRewardTypeLabel(type) {
      const found = this.rewardTypes.find(t => t.value === type);
      return found ? found.label : type;
    },

    getUnlockTypeLabel(type) {
      const found = this.unlockTypes.find(t => t.value === type);
      return found ? found.label : type;
    },

    formatDate(dateString) {
      if (!dateString) return '-';
      return new Date(dateString).toLocaleDateString();
    },

    getQuestName(questId) {
      const quest = this.model.quests[questId];
      return quest ? quest.name : 'Unknown Quest';
    },

    getEventName(eventId) {
      const event = this.model.events[eventId];
      return event ? event.name : 'Unknown Event';
    },

    getChestDisplay(reward) {
      const chest = this.model.chests[reward.chest_type];
      if (!chest) {
        return `${reward.chest_type} (${reward.is_guaranteed ? 'Guaranteed' : reward.drop_rate + '%'})`;
      }

      const chestName = chest.name || reward.chest_type;
      const dropInfo = reward.is_guaranteed ? 'Guaranteed' : (reward.drop_rate + '%');

      // Build list of guaranteed card types
      const guaranteed = [];
      if (chest.legendaryGuaranteed) guaranteed.push('Legendary');
      if (chest.ultraGuaranteed) guaranteed.push('Ultra');
      if (chest.boneCardGuaranteed) guaranteed.push('Bone Card');

      if (guaranteed.length > 0) {
        return `${chestName} - Guaranteed: ${guaranteed.join(', ')} (${dropInfo})`;
      }

      return `${chestName} (${dropInfo})`;
    },

    toggleActive(id, type) {
      const c = this;

      // Get reward from appropriate collection
      let reward = type === 'background'
        ? c.model.rewardBackgrounds[id]
        : c.model.rewardFrames[id];

      reward.is_active = !reward.is_active;

      // Save to appropriate service
      const service = type === 'background' ? rewardBackgroundService : rewardFrameService;

      service.save(reward)
        .then(function (response) {
          if (response.success) {
            c.getRewardFrames();
            c.getRewardBackgrounds();
          }
        })
        .catch(function (error) {
          console.error(error);
          c.getRewardFrames();
          c.getRewardBackgrounds();
        });
    },

    // New method for editing events
    editEvent(eventId) {
      const c = this;
      const event = c.model.events[eventId];
      if (event) {
        // Navigate to event edit page or open event edit modal
        // This depends on your application's routing structure
        console.log('Edit event:', event);
        // Example: window.location.href = `/admin/events/edit/${eventId}`;
      }
    },

    // New method for toggling event active status
    toggleEventActive(eventId) {
      const c = this;
      const event = c.model.events[eventId];
      if (event) {
        event.is_active = !event.is_active;
        // Save event using your event service
        // eventsService.save(event).then(...)
        console.log('Toggle event active:', event);
      }
    }
  }
});